export default __webpack_public_path__ + "static/media/flower04.aaeb30f7.mp4";